import { Actions, createEffect, ofType } from "@ngrx/effects";
import { exhaustMap, map, switchMap } from "rxjs/operators";
import { DataActions, ProjectViewActions } from "../actions";

import { Injectable } from "@angular/core";
import { ProjectView } from "@app/project/model/project-view";
import { ProjectViewDbService } from "@app/project/services/project-view-db.service";
import { EffectsUtils } from "@app/root-store/effects/effect-creators";
import { DeleteConfirmationService } from "@app/shared/components/delete-confirmation/delete-confirmation.service";
import { ActionWord } from "@app/shared/resources/action-word";
import { Observable } from "rxjs";
import { ActionPayload } from "../actions/project-view.actions";

@Injectable()
export class ProjectViewEffects extends EffectsUtils {
    constructor(actions$: Actions, private deleteConfirmationService: DeleteConfirmationService, private dbService: ProjectViewDbService) {
        super(actions$);
    }

    private wrapResult(this: void, source$: Observable<ProjectView>) {
        return source$.pipe(map(result => ({ projectView: result })));
    }

    load$ = createEffect(() =>
        this.actions$.pipe(
            ofType(ProjectViewActions.load),
            switchMap(({ entityId, userId }) =>
                DataActions.toAction2()(
                    // this.dbService.getProjectViews(entityId, userId).pipe(this.wrapBulkResult),
                    this.dbService.getProjectViewForUserOrEntity(entityId, userId).pipe(map(result => ({ projectViews: result }))),
                    ProjectViewActions.loadSuccess,
                    ProjectViewActions.loadFailure
                )
            )
        )
    );

    create$ = createEffect(() =>
        this.actions$.pipe(
            ofType(ProjectViewActions.create),
            exhaustMap(({ projectView, callbackEmitter }) =>
                DataActions.toAction2()(
                    // this.dbService.create({ data: projectView, logData: { projectView } }).pipe(this.wrapResult),
                    this.dbService.createProjectView(projectView).pipe(this.wrapResult),
                    ProjectViewActions.createSuccess,
                    ProjectViewActions.createFailure,
                    callbackEmitter
                )
            )
        )
    );

    createProjectViewFailure$ = this.createFailureEffect(ProjectViewActions.createFailure, ActionWord.saved);

    update$ = createEffect(() =>
        this.actions$.pipe(
            ofType(ProjectViewActions.update),
            exhaustMap(({ projectView, callbackEmitter }) =>
                DataActions.toAction2()(
                    this.dbService.updateProjectView(projectView).pipe(
                        map(_ => projectView),
                        this.wrapResult
                    ),
                    ProjectViewActions.updateSuccess,
                    ProjectViewActions.updateFailure,
                    callbackEmitter
                )
            )
        )
    );

    updateProjectViewFailure$ = this.createFailureEffect(ProjectViewActions.updateFailure, ActionWord.saved);

    delete$ = createEffect(() =>
        this.actions$.pipe(
            ofType(ProjectViewActions.deleteItem),
            exhaustMap(({ projectView, callbackEmitter, authUser }) =>
                DataActions.toAction2()(
                    this.dbService.deleteProjectView(projectView).pipe(map(_ => ({ projectView, authUser }))),
                    ProjectViewActions.deleteSuccess,
                    ProjectViewActions.deleteFailure,
                    callbackEmitter
                )
            )
        )
    );

    deleteProjectViewFailure$ = this.createFailureEffect(ProjectViewActions.deleteFailure, ActionWord.deleted);

    deleteConfirmation$ = createEffect(() =>
        this.actions$.pipe(
            ofType(ProjectViewActions.deleteConfirmation),
            exhaustMap(({ projectView, callbackEmitter, authUser }) =>
                this.deleteConfirmationService.open$<ActionPayload>(
                    { projectView, callbackEmitter, authUser },
                    ProjectViewActions.deleteDismiss,
                    ProjectViewActions.deleteItem,
                    `this ${this.dbService.helper.dbTypeName}`
                )
            )
        )
    );
}
